import React, { RefObject } from 'react';
import { Theme } from '@mui/material';
import { createStyles, withStyles, WithStyles } from '@mui/styles';

import { withTranslation, WithTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';

import StoreModel from '../../models/Index';
import { Services } from '../../helpers/constants/Services';
import { history } from '../../helpers/History';
import { KioskApplication } from '../../models/common/KioskApplication';

interface ApplicationFrameState {
    frameRef: RefObject<HTMLIFrameElement>;
}
interface ApplicationFrameProps
    extends WithStyles<typeof styles>,
    WithTranslation {
    app: KioskApplication;
}
interface ApplicationFramePropsInjected extends ApplicationFrameProps {
    Store: StoreModel;
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            marginLeft: '10%',
            marginRight: '10%',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '75vh',
        },

        iframe: {
            border: '0',
            width: '100%',
            height: '100%',
        },
    });

@inject(Services.STORE)
@observer
class ApplicationFrame extends React.Component<
    ApplicationFrameProps,
    ApplicationFrameState
> {
    /**
     * We really need to track if component is unmounted, to prevent
     * cases when we are doing history.goBack() when component is unmounted
     * Handshake promise could be so long
     * @memberof ApplicationFrame
     */
    _isUnmounted = false;

    get injected() {
        return this.props as ApplicationFramePropsInjected;
    }

    constructor(e: ApplicationFrameProps) {
        super(e);

        this.state = {
            frameRef: React.createRef(),
        };
    }

    componentDidMount() {
        const { frameRef } = this.state;

        if (!frameRef.current) {
            return history.goBack();
        }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
        const { Store } = this.injected;

        if (Store.sdk.currentAppFrame !== null) {
            console.warn(
                'ApplicationFrame was closed in not graceful maner... Please check if you are using sdk.closeApp method for closing sub-applications'
            );
            Store.sdk.currentAppFrame = null;
        }
    }

    render() {
        const { frameRef } = this.state;
        const { app, classes } = this.props;
        const { Store } = this.injected;

        return (
            <div className={classes.root}>
                <iframe
                    title='ApplicationFrame'
                    ref={frameRef}
                    className={classes.iframe}
                    src={app.url}
                    onLoad={() =>
                        Store.sdk.openApp(app, frameRef.current!.contentWindow)
                    }
                    onError={() => history.goBack()}
                ></iframe>
            </div>
        );
    }
}

export default withTranslation()(withStyles(styles)(ApplicationFrame));
